// export default function PrintPreviewComponent

import { Divider } from '@material-ui/core';
import RegularButton from 'components/CustomButtons/Button';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { LoginContext } from 'contexts/LoginContext';
import jsPDF from 'jspdf';
import { useContext, useEffect, useState } from 'react';
import testPreviewService from 'services/Preview/testPreviewService';

// const questionsData = {
//     "$id": "1",
//     "providerId": 3043,
//     "welcomeMessage": "Welcome",
//     "concludeMessage": "Thank You!",
//     "feedbackFail": "Failed",
//     "feedbackPass": "Pass",
//     "feedbackmastery": "Excellent!",
//     "totalScore": 20,
//     "passingScore": 5,
//     "masteryScore": null,
//     "pointsPerQuestion": 4,
//     "negativePointsPerQuestion": 0,
//     "showHint": 2,
//     "showBookmark": 1,
//     "showTimer": 2,
//     "showResult": 2,
//     "questionsPerPage": 1,
//     "duration": 60,
//     "navigation": 2,
//     "totalCount": 5,
//     "pools": {
//         "$id": "2",
//         "$values": [
//             {
//                 "$id": "3",
//                 "id": 3213,
//                 "text": "ST1-Copy-Copy",
//                 "sequence": 1,
//                 "poolScore": 0,
//                 "masteryScore": 0,
//                 "isMandatoryToPass": false,
//                 "topics": null,
//                 "questionCount": 2,
//                 "noOfChoices": null,
//                 "choiceFormat": null,
//                 "maxQuestionForScore": null,
//                 "pointsPerQuestion": 0,
//                 "negativePointsPerQuestion": 0,
//                 "questions": {
//                     "$id": "4",
//                     "$values": [
//                         {
//                             "$id": "5",
//                             "id": 5421,
//                             "poolId": 3213,
//                             "code": null,
//                             "text": "In \"Sholay\", what was the name of Basanti's horse?",
//                             "providerId": 0,
//                             "status": null,
//                             "questionId": 0,
//                             "options": {
//                                 "$id": "6",
//                                 "$values": [
//                                     "a) Asha",
//                                     " b) Dhano",
//                                     " c) Jay",
//                                     " d) Leela",
//                                     " e) Viru",
//                                     null
//                                 ]
//                             },
//                             "answer": " b) Dhano",
//                             "type": "SCQ",
//                             "difficultyLevel": null,
//                             "questionType": null,
//                             "contentType": 1,
//                             "choicesAlignment": 1,
//                             "hint": "This should be simle, no hint needed",
//                             "points": 4,
//                             "negativePoints": 0,
//                             "isMandatory": 0,
//                             "sequence": 1,
//                             "poolSequence": 1,
//                             "image": null,
//                             "solution": null,
//                             "solutionText": "Solution text 1",
//                             "paragraphText": null,
//                             "paragraphImage": null
//                         },
//                         {
//                             "$id": "13",
//                             "id": 5425,
//                             "poolId": 3213,
//                             "code": null,
//                             "text": "Who is know as the nightingale of India",
//                             "providerId": 0,
//                             "status": null,
//                             "questionId": 0,
//                             "options": {
//                                 "$id": "14",
//                                 "$values": [
//                                     "a) Savitibai Phule",
//                                     " b) Sarojini Naidu",
//                                     null,
//                                     null,
//                                     null,
//                                     null
//                                 ]
//                             },
//                             "answer": " b) Sarojini Naidu",
//                             "type": "SCQ",
//                             "difficultyLevel": null,
//                             "questionType": null,
//                             "contentType": 1,
//                             "choicesAlignment": 1,
//                             "hint": "She was born in 1879",
//                             "points": 4,
//                             "negativePoints": 0,
//                             "isMandatory": 0,
//                             "sequence": 5,
//                             "poolSequence": 1,
//                             "image": null,
//                             "solution": null,
//                             "solutionText": "Solution text 5",
//                             "paragraphText": null,
//                             "paragraphImage": null
//                         },
//                         {
//                             "$id": "7",
//                             "id": 5422,
//                             "poolId": 3213,
//                             "code": null,
//                             "text": "In \"Sholay\", what was the name of Basanti's horse?",
//                             "providerId": 0,
//                             "status": null,
//                             "questionId": 0,
//                             "options": {
//                                 "$id": "6",
//                                 "$values": [
//                                     "a) Asha",
//                                     " b) Dhano",
//                                     " c) Jay",
//                                     " d) Leela",
//                                     " e) Viru",
//                                     null
//                                 ]
//                             },
//                             "answer": " b) Dhano",
//                             "type": "SCQ",
//                             "difficultyLevel": null,
//                             "questionType": null,
//                             "contentType": 1,
//                             "choicesAlignment": 1,
//                             "hint": "This should be simle, no hint needed",
//                             "points": 4,
//                             "negativePoints": 0,
//                             "isMandatory": 0,
//                             "sequence": 1,
//                             "poolSequence": 1,
//                             "image": null,
//                             "solution": null,
//                             "solutionText": "Solution text 1",
//                             "paragraphText": null,
//                             "paragraphImage": null
//                         },
//                         {
//                             "$id": "14",
//                             "id": 5427,
//                             "poolId": 3213,
//                             "code": null,
//                             "text": "Who is know as the nightingale of India",
//                             "providerId": 0,
//                             "status": null,
//                             "questionId": 0,
//                             "options": {
//                                 "$id": "14",
//                                 "$values": [
//                                     "a) Savitibai Phule",
//                                     " b) Sarojini Naidu",
//                                     "C",
//                                     "D",
//                                     "E",
//                                     "F"
//                                 ]
//                             },
//                             "answer": " b) Sarojini Naidu",
//                             "type": "SCQ",
//                             "difficultyLevel": null,
//                             "questionType": null,
//                             "contentType": 1,
//                             "choicesAlignment": 1,
//                             "hint": "She was born in 1879",
//                             "points": 4,
//                             "negativePoints": 0,
//                             "isMandatory": 0,
//                             "sequence": 5,
//                             "poolSequence": 1,
//                             "image": "data:image/png;base64,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",
//                             "solution": null,
//                             "solutionText": "Solution text 5",
//                             "paragraphText": null,
//                             "paragraphImage": null
//                         },
//                         {
//                             "$id": "67",
//                             "id": 5429,
//                             "poolId": 3213,
//                             "code": null,
//                             "text": "In \"Sholay\", what was the name of Basanti's horse?",
//                             "providerId": 0,
//                             "status": null,
//                             "questionId": 0,
//                             "options": {
//                                 "$id": "6",
//                                 "$values": [
//                                     "a) Asha",
//                                     " b) Dhano",
//                                     " c) Jay",
//                                     " d) Leela",
//                                     " e) Viru",
//                                     null
//                                 ]
//                             },
//                             "answer": " b) Dhano",
//                             "type": "SCQ",
//                             "difficultyLevel": null,
//                             "questionType": null,
//                             "contentType": 1,
//                             "choicesAlignment": 1,
//                             "hint": "This should be simle, no hint needed",
//                             "points": 4,
//                             "negativePoints": 0,
//                             "isMandatory": 0,
//                             "sequence": 1,
//                             "poolSequence": 1,
//                             "image": "data:image/png;base64,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",
//                             "solution": null,
//                             "solutionText": "Solution text 1",
//                             "paragraphText": null,
//                             "paragraphImage": null
//                         },
//                         {
//                             "$id": "5",
//                             "id": 2376,
//                             "poolId": 113,
//                             "code": null,
//                             "text": null,
//                             "providerId": 0,
//                             "status": null,
//                             "questionId": 0,
//                             "options": {
//                                 "$id": "6",
//                                 "$values": [
//                                     "(A)",
//                                     "(B)",
//                                     "(C)",
//                                     "(D)",
//                                     "(E)",
//                                     null
//                                 ]
//                             },
//                             "answer": "[\"a)\",\"d)\"]",
//                             "type": "MCQ",
//                             "difficultyLevel": null,
//                             "questionType": null,
//                             "contentType": 1,
//                             "choicesAlignment": 1,
//                             "hint": null,
//                             "points": 5,
//                             "negativePoints": -1,
//                             "isMandatory": 0,
//                             "sequence": 1,
//                             "poolSequence": 1,
//                             "image": "data:image/png;base64,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",
//                             "solution": null,
//                             "solutionText": null,
//                             "paragraphText": null,
//                             "paragraphImage": null
//                         },
//                         {
//                             "$id": "18",
//                             "id": 5428,
//                             "poolId": 3213,
//                             "code": null,
//                             "text": "Who is know as the nightingale of India",
//                             "providerId": 0,
//                             "status": null,
//                             "questionId": 0,
//                             "options": {
//                                 "$id": "14",
//                                 "$values": [
//                                     "a) Savitibai Phule",
//                                     " b) Sarojini Naidu",
//                                     "C",
//                                     "D",
//                                     "E",
//                                     "F"
//                                 ]
//                             },
//                             "answer": " b) Sarojini Naidu",
//                             "type": "SCQ",
//                             "difficultyLevel": null,
//                             "questionType": null,
//                             "contentType": 1,
//                             "choicesAlignment": 1,
//                             "hint": "She was born in 1879",
//                             "points": 4,
//                             "negativePoints": 0,
//                             "isMandatory": 0,
//                             "sequence": 5,
//                             "poolSequence": 1,
//                             "image": null,
//                             "solution": null,
//                             "solutionText": "Solution text 5",
//                             "paragraphText": null,
//                             "paragraphImage": null
//                         }
//                     ]
//                 }
//             },
//             {
//                 "$id": "4",
//                 "id": 3214,
//                 "text": "ST2-Copy-Copy",
//                 "sequence": 2,
//                 "poolScore": 0,
//                 "masteryScore": 0,
//                 "isMandatoryToPass": false,
//                 "topics": null,
//                 "questionCount": 2,
//                 "noOfChoices": null,
//                 "choiceFormat": null,
//                 "maxQuestionForScore": null,
//                 "pointsPerQuestion": 0,
//                 "negativePointsPerQuestion": 0,
//                 "questions": {
//                     "$id": "4",
//                     "$values": [
//                         {
//                             "$id": "5",
//                             "id": 5422,
//                             "poolId": 3214,
//                             "code": null,
//                             "text": "In \"Sholay\", what was the name of Basanti's horse?",
//                             "providerId": 0,
//                             "status": null,
//                             "questionId": 0,
//                             "options": {
//                                 "$id": "6",
//                                 "$values": [
//                                     "a) Asha",
//                                     " b) Dhano",
//                                     " c) Jay",
//                                     " d) Leela",
//                                     " e) Viru",
//                                     null
//                                 ]
//                             },
//                             "answer": " b) Dhano",
//                             "type": "SCQ",
//                             "difficultyLevel": null,
//                             "questionType": null,
//                             "contentType": 1,
//                             "choicesAlignment": 1,
//                             "hint": "This should be simle, no hint needed",
//                             "points": 4,
//                             "negativePoints": 0,
//                             "isMandatory": 0,
//                             "sequence": 1,
//                             "poolSequence": 1,
//                             "image": null,
//                             "solution": null,
//                             "solutionText": "Solution text 1",
//                             "paragraphText": null,
//                             "paragraphImage": null
//                         },
//                         {
//                             "$id": "6",
//                             "id": 5426,
//                             "poolId": 3214,
//                             "code": null,
//                             "text": "Who is know as the nightingale of India",
//                             "providerId": 0,
//                             "status": null,
//                             "questionId": 0,
//                             "options": {
//                                 "$id": "14",
//                                 "$values": [
//                                     "a) Savitibai Phule",
//                                     " b) Sarojini Naidu",
//                                     null,
//                                     null,
//                                     null,
//                                     null
//                                 ]
//                             },
//                             "answer": " b) Sarojini Naidu",
//                             "type": "SCQ",
//                             "difficultyLevel": null,
//                             "questionType": null,
//                             "contentType": 1,
//                             "choicesAlignment": 1,
//                             "hint": "She was born in 1879",
//                             "points": 4,
//                             "negativePoints": 0,
//                             "isMandatory": 0,
//                             "sequence": 5,
//                             "poolSequence": 1,
//                             "image": null,
//                             "solution": null,
//                             "solutionText": "Solution text 5",
//                             "paragraphText": null,
//                             "paragraphImage": null
//                         }
//                     ]
//                 }
//             }
//         ]
//     }
// };


const PrintPreviewComponent = ({ pageSize, testId, testName }) => {
    const { userPrivileges } = useContext(LoginContext);
    const [questionsData, setPreviewTest] = useState([])
    console.log(questionsData, "ajacaca");
    const [isLoading, setIsLoading] = useState(false);
    const [questions, setQuestions] = useState([])
    const getSync = async () => {
        try {
            setIsLoading(true);
            let response = await testPreviewService.getPreviewTests(testId, 1, pageSize);
            console.log(response?.data, 'Allquestions');
            setPreviewTest(response?.data);

            console.log(response?.data, 'previewTest')
            let rtest = response?.data?.pools["$values"].map((x, i) => {
                x.questions["$values"].forEach((y) => {
                    y.poolText = x.text;
                    y.poolId = x.id;
                    y.isMandatoryToPass = x.isMandatoryToPass;
                    y.poolScore = x.poolScore;
                    y.response = null;
                    y.isCorrect = false;
                });

                return x.questions["$values"];
            });

            rtest = rtest.flat();

            const qPerPage = response?.data?.questionsPerPage;
            // console.log("ExpiryDate",test.ExpiryDate);
            let c = 0;
            let currentPool = "";
            let index = 0;

            let mdata = rtest.reduce((acc, cur) => {
                if (cur.id === 0) {
                    return acc;
                }
                if (currentPool == "") {
                    currentPool = cur.poolText;
                }

                if (c == qPerPage || currentPool != cur.poolText) {
                    c = 0;
                    currentPool = cur.poolText;
                    index++;
                }

                if (!acc[index]) {
                    acc[index] = [];
                }
                console.log("acbjaka", acc);
                acc[index].push(cur);
                c++;

                return acc;
            }, []);

            setQuestions(mdata);
            setIsLoading(false);

        } catch (error) {
            console.error('Error:', error);
            setIsLoading(false);
        } finally {
            console.log('error occured')
            setIsLoading(false);
        }
        // setIsLoading(false);
    }

    useEffect(() => {
        console.log('calling')
        getSync();
    }, [])

    function convertMinutesToHMS(mins) {
        // Convert minutes to hours and minutes
        const hours = Math.floor(mins / 60);
        const minutes = mins % 60;

        // Format hours, minutes, and seconds to hh:mm:ss
        const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2)}`;

        return formattedTime;
    }

    const generatePDF = async () => {
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageHeight = 297; // A4 page height in mm
        const pageWidth = 210;  // A4 page width in mm
        const margin = 10; // Margin in mm
        const textWidth = pageWidth - 2 * margin; // Text width considering margins
        let yPosition = margin;
        let currentPage = 1;
        let questionNumber = 1;

        const headingText = testName;
        const duration = `Duration: ${convertMinutesToHMS(questionsData.duration)} hours`; // Example duration
        const totalScore = `Total Score: ${questionsData.totalScore}`; // Example total score

        const addPageNumber = () => {
            pdf.text(`Page ${currentPage}`, pageWidth - margin - 20, pageHeight - margin);
            currentPage++;
        };

        const addTextToPDF = (text, x, y) => {
            pdf.text(text, x, y);
        };

        const handlePageBreak = (height) => {
            if (yPosition + height > pageHeight - margin) {
                addPageNumber(); // Add page number before adding a new page
                pdf.addPage();
                yPosition = margin;
            }
        };

        // Add heading and details to the first page
        pdf.setFontSize(16);
        pdf.setFont("helvetica", "bold");

        // Center align heading
        const headingWidth = pdf.getTextWidth(headingText);
        const headingX = (pageWidth - headingWidth) / 2; // Center position for heading
        addTextToPDF(headingText, headingX, yPosition);
        yPosition += 20; // Add space below the heading

        pdf.setFontSize(12);
        pdf.setFont("helvetica", "normal");

        // Add duration and total score
        const durationText = duration;
        const totalScoreText = totalScore;

        const durationWidth = pdf.getTextWidth(durationText);
        const totalScoreWidth = pdf.getTextWidth(totalScoreText);

        addTextToPDF(durationText, margin, yPosition); // Left align duration
        addTextToPDF(totalScoreText, pageWidth - margin - totalScoreWidth, yPosition); // Right align total score

        // Add horizontal line
        yPosition += 10; // Add some space below the text
        pdf.setDrawColor(0); // Black color for the line
        pdf.setLineWidth(0.5); // Line width in mm
        pdf.line(margin, yPosition, pageWidth - margin, yPosition); // Draw line
        yPosition += 10; // Add space below the line

        for (const pool of questionsData.pools?.$values) {
            for (const question of pool.questions?.$values) {
                const questionText = question.text;
                const questionOptions = question.options.$values.filter(option => option).join('\n');

                const questionContent = `${questionText}\n\n${questionOptions}`;

                // Create a temporary div to measure text height
                const tempDiv = document.createElement('div');
                tempDiv.style.position = 'absolute';
                tempDiv.style.visibility = 'hidden';
                tempDiv.style.width = `${textWidth}mm`; // Width of the PDF page minus margins
                tempDiv.innerText = questionContent;
                document.body.appendChild(tempDiv);

                const textHeight = tempDiv.offsetHeight * 0.264583; // Convert px to mm
                document.body.removeChild(tempDiv);

                if (question.image) {
                    try {
                        // Load image and calculate height
                        const imageHeight = await new Promise((resolve, reject) => {
                            const img = new Image();
                            img.src = question.image;
                            img.onload = () => {
                                const imgWidth = textWidth; // Width in mm
                                const imgHeight = (img.height / img.width) * imgWidth; // Height in mm
                                resolve(imgHeight);
                            };
                            img.onerror = reject;
                        });

                        // Add image to PDF
                        const img = new Image();
                        img.src = question.image;
                        await new Promise((resolve, reject) => {
                            img.onload = () => {
                                const imgWidth = textWidth; // Width in mm
                                handlePageBreak(imageHeight + 20); // Add space for image and margin
                                pdf.addImage(question.image, 'PNG', margin, yPosition, imgWidth, imageHeight);
                                yPosition += imageHeight + 10; // Move down for the question options
                                resolve();
                            };
                            img.onerror = reject;
                        });

                        // Add question number with image
                        const questionNumberText = `${questionNumber}.`;
                        const numberWidth = pdf.getTextWidth(questionNumberText); // Measure width of question number
                        const textX = margin + numberWidth + 2; // Position text after the number
                        addTextToPDF(questionNumberText, margin, yPosition - imageHeight - 10); // Above the image

                        // Add question options
                        if (questionOptions) {
                            handlePageBreak(textHeight + 10); // Check if options fit on the page
                            addTextToPDF(questionOptions, margin, yPosition);
                            yPosition += textHeight + 10; // Move down for the next content
                        }
                    } catch (error) {
                        console.error('Error loading image:', error);
                    }
                } else {
                    // Add question number with text
                    const questionWithNumber = `${questionNumber}. ${questionContent}`;
                    handlePageBreak(textHeight + 10); // Check if text fits on the page
                    addTextToPDF(questionWithNumber, margin, yPosition);
                    yPosition += textHeight + 10; // Move down for the next content
                }

                questionNumber++; // Increment question number
            }
        }

        // Add the last page number if necessary
        addPageNumber();

        pdf.save('question-paper.pdf');
    };
    return (
        <div>
            {
                isLoading ? <h3 style={{ color: 'black' }} > Loading Preview...</h3 > :
                    <div id="print-content" style={{ border: '1px solid black', padding: '2%', width: '70%' }}>
                        <div style={{ textAlign: 'center', color: 'black' }}>
                            {/* <h3>{`Sample Question Paper`}</h3> */}
                            <h4 style={{ fontWeight: 'bold' }}>{`${testName} `}</h4>
                            {/* <h4>{`CLASS XII (2023-24)`}</h4> */}
                        </div>
                        <div style={{ color: 'black' }}>
                            <p style={{ float: 'left', fontWeight: 'bold' }}>{`Time ${convertMinutesToHMS(questionsData?.duration)} Hours`}</p>
                            <p style={{ float: 'right', fontWeight: 'bold' }}>{`Total. Marks ${questionsData?.totalScore}`}</p>
                        </div>
                        <div style={{ marginTop: '10%' }}>
                            <Divider />
                        </div>
                        <div style={{ marginTop: '5%' }}>
                            {
                                questions.map((x, i) => (
                                    <ul style={{ listStyleType: 'none', color: 'black', marginTop: '5%' }}>
                                        {
                                            x[0].image != null ?
                                                <li>{`Q ${i + 1}. `}<img src={x[0].image} alt="React Image" style={{ width: '-webkit-fill-available' }} /></li>
                                                : null
                                        }
                                        {
                                            x[0].text != null && x[0].text != "" ?
                                                <li style={{ fontWeight: '500' }} >{`Q ${i + 1}.${x[0].text}`}</li>
                                                : null
                                        }
                                        {x[0].image == null ?
                                            <GridContainer style={{ padding: '10px 50px', width: 'calc(100% + 16px)' }}>
                                                {
                                                    x[0]?.options["$values"].map((x, i) => (
                                                        x != null ?
                                                            <GridItem xs={5} sm={5} md={10} lg={10}>
                                                                <p style={{ fontWeight: '500' }}>{x}</p>
                                                            </GridItem> : ''

                                                    ))
                                                }
                                            </GridContainer> : null

                                        }
                                    </ul>
                                    // console.log(x[0], 'questions123')
                                ))
                            }
                        </div>
                    </div>
            }
            <RegularButton color="primary" disabled={(isLoading == true || userPrivileges?.PackageId == 4)} onClick={generatePDF}>Generate PDF
            </RegularButton>
        </div>
    );
};

export default PrintPreviewComponent;
